import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineTheme";

const url = "/api/machines/MachineTheme";

export const machineThemeLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Theme",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
